import { Link } from "react-router-dom";
import SearchBar from "../../../../common-elements/search-bar/SearchBar";

interface SMSHeaderProps {
  searchWord: string;
  setSearchWord: (value: string) => void;
  setComposeSMS: (value: boolean) => void;
}

const SMSHeader: React.FC<SMSHeaderProps> = ({
  searchWord,
  setSearchWord,
  setComposeSMS,
}) => {
  return (
    <div
      className="mail-header-wrapper"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 15px",
        width: "100%",
      }}
    >
      <div
        className="mail-left"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          flex: "1",
        }}
      >
        <SearchBar
          label="Search"
          value={searchWord}
          onChange={(e) => setSearchWord(e.target.value)}
          placeholder="Search by SMS"
        />
      </div>
      <div
        className="mail-right"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link
          className="btn btn-primary"
          to={`${process.env.PUBLIC_URL}/communication/compose-sms`}
          onClick={() => setComposeSMS(true)}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
          }}
        >
          {"Compose SMS"}
        </Link>
      </div>
    </div>
  );
};

export default SMSHeader;
